var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticStyle:{"width":"50px","display":"inline-block","text-align":"center"}},[_vm._v(_vm._s(this.number))])}
var staticRenderFns = []

export { render, staticRenderFns }